import apiClient from 'services/axios'

export async function fetchSubAgents(agentId) {
  return apiClient
    .get(`agent/${agentId}/sub-agents`)
    .then(response => {
      return response.data
    })
    .catch(err => console.log(err))
}

export async function createSubAgent(agentId, data) {
  return apiClient
    .post(`agent/${agentId}/sub-agents`, data)
    .then(response => {
      return response.data
    })
    .catch(err => console.log(err))
}

export async function updateSubAgent(agentId, subAgentId, data) {
  return apiClient
    .put(`agent/${agentId}/sub-agents/${subAgentId}`, data)
    .then(response => {
      return response.data
    })
    .catch(err => console.log(err))
}

export async function assignMerchantToSubAgent(agentId, subAgentId, data) {
  return apiClient
    .post(`agent/${agentId}/sub-agents/${subAgentId}/assign`, data)
    .then(response => {
      return response.data
    })
    .catch(err => console.log(err))
}

export async function fetchSalesAgentById(agentId) {
  return apiClient
    .get(`agent/${agentId}/full`)
    .then(response => {
      return response.data
    })
    .catch(err => console.log(err))
}

export async function fetchBusinessStats() {
  return apiClient
    .get('/stats/businesses')
    .then(response => {
      return response.data
    })
    .catch(err => console.log(err))
}

export async function WalletStatistics() {
  return apiClient
    .get('/stats/wallets')
    .then(response => {
      return response.data
    })
    .catch(err => console.log(err))
}

export async function fetchUserStats() {
  return apiClient
    .get('/stats/users')
    .then(response => {
      return response.data
    })
    .catch(err => console.log(err))
}
export async function fetchMonthlyAgentCommission(agentId, month, year, includeDetails = false) {
  return apiClient
    .get(`agent/sales-agent/${agentId}/monthly-commission`, {
      params: { month, year, includeDetails: includeDetails.toString() },
    })
    .then(response => response.data)
    .catch(err => console.log(err))
}

export async function fetchYearlyAgentCommission(agentId, year) {
  return apiClient
    .get(`agent/sales-agent/${agentId}/yearly-commission`, {
      params: { year },
    })
    .then(response => response.data)
    .catch(err => console.log(err))
}

export async function fetchRateDetails(businessId) {
  return apiClient
    .get(`agent/${businessId}/merchant-fee`) // Note: checked agent.route.js for correct path
    .then(response => response.data)
    .catch(err => console.log(err))
}

export async function fetchAgentPayouts(agentId) {
  return apiClient
    .get(`agent/${agentId}/payouts`)
    .then(response => response.data)
    .catch(err => console.log(err))
}

export async function removeMerchantFromSubAgent(agentId, subAgentId, businessId) {
  return apiClient
    .delete(`agent/${agentId}/sub-agents/${subAgentId}/merchant/${businessId}`)
    .then(response => response.data)
    .catch(err => console.log(err))
}
